import type { StoreState } from 'client/store'
import { getActiveSubscription } from 'client/utilities/getActiveSubscription'
import type { Subscription } from 'client/reducers/userReducer'
import { useSelector } from 'react-redux'
import { SubscriptionType } from 'client/enums/SubscriptionType'
import { useMemo } from 'react'

type ActiveSubscription = {
  subscription: Subscription
  hasSubscription: boolean
  hasLightSubscription: boolean
  hasPremiumSubscription: boolean
}

const useActiveSubscription = (): ActiveSubscription => {
  const subscriptions = useSelector<StoreState, Subscription[]>((state) => state.user?.data?.subscriptions) ?? []
  const activeSubscription = getActiveSubscription(subscriptions)

  return useMemo<ActiveSubscription>(() => (
    {
      subscription: activeSubscription,
      hasSubscription: !!activeSubscription,
      hasLightSubscription:
        activeSubscription?.subscriptionTypeName === SubscriptionType.light
        || activeSubscription?.subscriptionTypeName === SubscriptionType.lightTrial
        || activeSubscription?.subscriptionTypeName === SubscriptionType.extendedTrial,
      hasPremiumSubscription: activeSubscription?.subscriptionTypeName === SubscriptionType.premium,
    }
  ), [activeSubscription])
}

export default useActiveSubscription
